import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { NodeSpec } from './NodeSpec';
import type { NodeCfg } from '@redviking/argonaut-util/types/mes/applet-designs/flow.latest';
import { defineControlOpts } from '../../controls/FlowNodeControl';
import { defaultControlUpdateValueHandler } from '@redviking/argonaut-core-ui/src/applet/design/flows/controls/control-event-handler';

export const numberNodeSpec: NodeSpec<NodeCfg<'number'>> = {
    requiredSockets: 'all',
    cfg: () => ({ controlValues: { value: 0 }, id: getUID(), kind: 'number', disabled: false }),
    controls: nodeCfg => ({
        value: defineControlOpts({ cfg: { kind: 'number', label: 'Value' }, on: { 'update:value': defaultControlUpdateValueHandler }, value: nodeCfg.controlValues.value }),
    }),
    inputs: () => ({}),
    kindLabel: 'Number',
    nodeCategory: 'number',
    outputs: () => ({ output: { socket: 'number', label: 'Output' } }),
    validator: node => typeof node.controlValues.value === 'number' && !isNaN(node.controlValues.value)
        ? true
        : { value: 'Value must be a number' },
};
